var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":(_vm.width + "px"),"height":(_vm.height + "px"),"viewBox":"0 0 100 100"}},[_c('polyline',{attrs:{"fill":_vm.color,"stroke":0,"stroke-width":"15","points":_vm.direction}})])}
var staticRenderFns = []

export { render, staticRenderFns }